/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Title from "./Title";
import { Dropdown } from "primereact/dropdown";
import { Slider } from "primereact/slider";
import { RadioButton } from "primereact/radiobutton";
import { getCarMakers } from "../services/btc-api.service";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";

const CustomSearch = ({
  onSearch,
  searchObj,
  setSearchObj,
  onClickReset,
  alreadyExpand,
  expanded,
  setExpanded,
  collapse,
}) => {
  const location = useLocation();
  const [selectedCity, setSelectedCity] = useState(null);
  const [ingredient, setIngredient] = useState("");
  const [carMakersData, setCarMakersData] = useState([]);
  const [formData, setFormData] = useState({
    steeringWheel: 'Unspecified',
    drivingSystem: 'Unspecified',
    transmission: 'Unspecified',
  });

  const handleCheckboxChange = (category, value) => {
    setFormData({
      ...formData,
      [category]: value,
    });
  };

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const fetchData = async () => {
    const carMakers = await getCarMakers();

    setCarMakersData(carMakers);
  };

  useEffect(() => {
    fetchData();

    if (alreadyExpand && alreadyExpand === true) {
      setExpanded(true);
    }
  }, []);

  return (
    <div className="custom-search-wrapper">
      {expanded && <Title text="Custom Search" />}

      {isMobile && expanded && (
        <div>
          <div className="container">
            <p className="reset-text" onClick={() => onClickReset()}>
              Reset
            </p>
            <div className="row text-center">
              <div
                className="col-6 col-md-3 col-lg-3"
                style={{ paddingRight: 5 }}
              >
                <input
                  type="text"
                  value={searchObj.stock}
                  placeholder="Stock Number"
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      stock: e.target.value,
                    })
                  }
                />
              </div>

              <div
                className="col-6 col-md-3 col-lg-3"
                style={{ paddingLeft: 5 }}
              >
                <Dropdown
                  value={searchObj.auctionType}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      auctionType: e.value,
                    })
                  }
                  options={[
                    { name: "LIVE", code: "LIVE" },
                    { name: "NEGOTIATIONS", code: "SUGGESTIONS" },
                    { name: "TENDER", code: "TENDER" },
                  ]}
                  optionLabel="name"
                  placeholder="Auction Type"
                  className="w-full md:w-14rem"
                />
              </div>
              <div className="col-12 col-md-3 col-lg-3" style={{ padding: 12 }}>
                <Dropdown
                  value={searchObj.maker}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      maker: e.value,
                    })
                  }
                  options={carMakersData}
                  optionLabel="name"
                  placeholder="Make"
                  className="w-full md:w-14rem"
                />
              </div>
              <div className="col-12 col-md-3 col-lg-3">
                <input
                  type="text"
                  value={searchObj.model}
                  placeholder="Model"
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      model: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="sliders-wrapper">
              <div className="col-12 col-md-6 col-lg-6 margin-bottom-5">
                <div className="slider-text-inline">
                  <span className="slider-left-text">Years</span>
                  <p className="range-text">
                    {searchObj.yearsStart + " to " + searchObj.yearsEnd}
                  </p>
                </div>
                <Slider
                  value={[searchObj.yearsStart, searchObj.yearsEnd]}
                  min={1960}
                  max={2023}
                  step={1}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      yearsStart: e.value[0],
                      yearsEnd: e.value[1],
                    })
                  }
                  range
                />
              </div>
              <br />
              <div className="col-12 col-md-6 col-lg-6 margin-bottom-5">
                <div className="slider-text-inline">
                  <span className="slider-left-text">Mileage</span>
                  <p className="range-text">
                    {searchObj.mileageStart +
                      "km to " +
                      searchObj.mileageEnd +
                      "km"}
                  </p>
                </div>
                <Slider
                  value={[searchObj.mileageStart, searchObj.mileageEnd]}
                  min={0}
                  max={100000}
                  step={1}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      mileageStart: e.value[0],
                      mileageEnd: e.value[1],
                    })
                  }
                  range
                />
              </div>
            </div>
            <div className="row text-center ">
              <div
                className="col-6 col-md-3 col-lg-3 margin-bottom-5"
                style={{ paddingRight: 5 }}
              >
                <Dropdown
                  value={searchObj.color}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      color: e.value,
                    })
                  }
                  options={[
                    { name: "RED", code: "RED" },
                    { name: "GREEN", code: "GREEN" },
                    { name: "BLUE", code: "BLUE" },
                    { name: "WHITE", code: "WHITE" },
                    { name: "PEARL", code: "PEARL" },
                    { name: "YELLOW", code: "YELLOW" },
                    { name: "ORANGE", code: "ORANGE" },
                    { name: "WINE", code: "WINE" },
                    { name: "PINK", code: "PINK" },
                    { name: "PURPLE", code: "PURPLE" },
                    { name: "BROWN", code: "BROWN" },
                    { name: "BAIGE", code: "BAIGE" },
                    { name: "GOLD", code: "GOLD" },
                    { name: "SILVER", code: "SILVER" },
                    { name: "GRAY", code: "GRAY" },
                    { name: "BLACK", code: "BLACK" },
                    { name: "OTHER", code: "OTHER" },
                  ]}
                  optionLabel="name"
                  placeholder="Color"
                  className="w-full md:w-14rem"
                />
              </div>
              <div
                className="col-6 col-md-3 col-lg-3 margin-bottom-5"
                style={{ paddingLeft: 5 }}
              >
                <Dropdown
                  value={searchObj.condition}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      condition: e.target.value,
                    })
                  }
                  options={[
                    { name: "DAMAGE", code: "DAMAGE" },
                    { name: "USED", code: "USED" },
                  ]}
                  optionLabel="name"
                  placeholder="Condition"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="sliders-wrapper">
              <div className="col-12 col-md-6 col-lg-6 margin-bottom-5 last-slider">
                <div className="slider-text-inline">
                  <span className="slider-left-text">Price</span>
                  <p className="range-text">
                    {searchObj.priceStart +
                      "yen to " +
                      searchObj.priceEnd +
                      "yen"}
                  </p>
                </div>
                <Slider
                  value={[searchObj.priceStart, searchObj.priceEnd]}
                  min={0}
                  max={10000000}
                  step={1}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      priceStart: e.value[0],
                      priceEnd: e.value[1],
                    })
                  }
                  range
                />
              </div>
            </div>
            <br />
            <div className="row text-center">
              <div className="col-12 col-md-6 col-lg-6 margin-bottom-5 display-flex-radios">
                <div className="col-4 col-md-2 col-lg-2 radios-border">
                  <div className="radios-heading">Steering Wheel</div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="UnspecifiedSteering"
                        name="UnspecifiedSteering"
                        value="Unspecified"
                        onChange={() => handleCheckboxChange('steeringWheel', 'Unspecified')}
                        checked={formData.steeringWheel.includes('Unspecified')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        Unspecified
                      </label>
                    </div>
                  </div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <div className="inner-radios">
                        <RadioButton
                          inputId="Unspecified"
                          name="Unspecified"
                          value="RHD"
                          onChange={() => handleCheckboxChange('steeringWheel', 'RHD')}
                          checked={formData.steeringWheel.includes('RHD')}
                        />

                        <label htmlFor="Unspecified" className="radios-label">
                          RHD
                        </label>
                      </div>
                    </div>
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="Unspecified"
                        name="Unspecified"
                        value="LHD"
                        onChange={() => handleCheckboxChange('steeringWheel', 'LHD')}
                        checked={formData.steeringWheel.includes('LHD')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        LHD
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-4 col-md-2 col-lg-2 radios-border">
                  <div className="radios-heading">Driving System</div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="UnspecifiedDriving"
                        name="UnspecifiedDriving"
                        value="Unspecified"
                        onChange={() => handleCheckboxChange('drivingSystem', 'Unspecified')}
                        checked={formData.drivingSystem.includes('Unspecified')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        Unspecified
                      </label>
                    </div>
                  </div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <div className="inner-radios">
                        <RadioButton
                          inputId="Unspecified"
                          name="Unspecified"
                          value="2WD"
                          onChange={() => handleCheckboxChange('drivingSystem', '2WD')}
                          checked={formData.drivingSystem.includes('2WD')}
                        />
                        <label htmlFor="Unspecified" className="radios-label">
                          2WD
                        </label>
                      </div>
                    </div>
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="Unspecified"
                        name="Unspecified"
                        value="4WD"
                        onChange={() => handleCheckboxChange('drivingSystem', '4WD')}
                        checked={formData.drivingSystem.includes('4WD')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        4WD
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-4 col-md-2 col-lg-2 radios-border">
                  <div className="radios-heading">Transmission</div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="UnspecifiedTransmission"
                        name="UnspecifiedTransmission"
                        value="Unspecified"
                        onChange={() => handleCheckboxChange('transmission', 'Unspecified')}
                        checked={formData.transmission.includes('Unspecified')}
                      />

                      <label htmlFor="Unspecified" className="radios-label">
                        Unspecified
                      </label>
                    </div>
                  </div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <div className="inner-radios">
                        <RadioButton
                          name="Unspecified"
                          value="AUTO"
                          onChange={() => handleCheckboxChange('transmission', 'AUTO')}
                          checked={formData.transmission.includes('AUTO')}
                        />
                        <label htmlFor="Unspecified" className="radios-label">
                          AT
                        </label>
                      </div>
                    </div>
                    <div
                      className="radio-outer-content"
                      style={{ marginLeft: 15 }}
                    >
                      <RadioButton
                        name="Unspecified"
                        value="MANUAL"
                        onChange={() => handleCheckboxChange('transmission', 'MANUAL')}
                        checked={formData.transmission.includes('MANUAL')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        MT
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div
                className="col-6 col-md-3 col-lg-3 margin-bottom-5"
                style={{ paddingRight: 5 }}
              >
                <Dropdown
                  value={searchObj.fuelType}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      fuelType: e.value,
                    })
                  }
                  options={[
                    { name: "GASOLINE", code: "GASOLINE" },
                    { name: "DIESEL", code: "DIESEL" },
                    { name: "HYBRID", code: "HYBRID" },
                    { name: "ELECTRIC", code: "ELECTRIC" },
                  ]}
                  optionLabel="name"
                  placeholder="Fuel Type"
                  className="w-full md:w-14rem"
                />
              </div>
              <div
                className="col-6 col-md-3 col-lg-3 margin-bottom-5"
                style={{ paddingLeft: 5 }}
              >
                <Dropdown
                  value={searchObj.bodyType}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      bodyType: e.value,
                    })
                  }
                  options={[
                    { name: "SEDAN", code: "SEDAN" },
                    { name: "COUPE", code: "COUPE" },
                    { name: "HATCHBACK", code: "HATCHBACK" },
                    { name: "STATION WAGON", code: "STATION WAGON" },
                    { name: "SUV", code: "SUV" },
                    { name: "PICK UP", code: "PICK UP" },
                    { name: "VAN", code: "VAN" },
                    { name: "MINI VAN", code: "MINI VAN" },
                    { name: "WAGON", code: "WAGON" },
                    { name: "CONVERTIBLE", code: "CONVERTIBLE" },
                    { name: "BUS", code: "BUS" },
                    { name: "TRUCK", code: "TRUCK" },
                    { name: "HEAVY EQUIP", code: "HEAVY EQUIP" },
                    { name: "FORKLIFT", code: "FORKLIFT" },
                    { name: "BIKE", code: "BIKE" },
                    { name: "KEI CAR", code: "KEI CAR" },
                  ]}
                  optionLabel="name"
                  placeholder="Body Type"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="btn-wrapper-search">
              <button
                className="search-btn-1"
                onClick={() => {
                  onSearch(searchObj, collapse);
                }}
              >
                <i
                  style={{ marginRight: 10 }}
                  className="fa fa-search"
                  aria-hidden="true"
                ></i>
                Search
              </button>
            </div>
          </div>
        </div>
      )}
      {isMobile === false && expanded === true && (
        <div>
          <div className="container">
            <p className="reset-text" onClick={() => onClickReset()}>
              Reset
            </p>
            <div className="row text-center">
              <div className="col-12 col-md-3 col-lg-3">
                <input
                  type="text"
                  placeholder="Stock Number"
                  className="w-full md:w-14rem rounded"
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      stock: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-6 col-md-3 col-lg-3">
                <Dropdown
                  value={searchObj.maker}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      maker: e.value,
                    })
                  }
                  options={carMakersData}
                  optionLabel="name"
                  placeholder="Make"
                  className="w-full md:w-14rem"
                />
              </div>
              <div className="col-6 col-md-3 col-lg-3">
                <input
                  type="text"
                  value={searchObj.model}
                  placeholder="Model"
                  className="w-full md:w-14rem rounded"
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      model: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-12 col-md-3 col-lg-3">
                <Dropdown
                  value={searchObj.auctionType}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      auctionType: e.value,
                    })
                  }
                  options={[
                    { name: "LIVE", code: "LIVE" },
                    { name: "NEGOTIATIONS", code: "SUGGESTIONS" },
                    { name: "TENDER", code: "TENDER" },
                  ]}
                  optionLabel="name"
                  placeholder="Auction Type"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="row text-center ">
              <div className="col-12 col-md-6 col-lg-6 margin-bottom-5">
                <div className="slider-text-inline">
                  <span className="slider-left-text">Years</span>
                  <p className="range-text">
                    {searchObj.yearsStart + " to " + searchObj.yearsEnd}
                  </p>
                </div>
                <Slider
                  value={[searchObj.yearsStart, searchObj.yearsEnd]}
                  min={1960}
                  max={2023}
                  step={1}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      yearsStart: e.value[0],
                      yearsEnd: e.value[1],
                    })
                  }
                  range
                />
              </div>
              <div className="col-6 col-md-3 col-lg-3 margin-bottom-5">
                <Dropdown
                  value={searchObj.color}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      color: e.value,
                    })
                  }
                  options={[
                    { name: "RED", code: "RED" },
                    { name: "GREEN", code: "GREEN" },
                    { name: "BLUE", code: "BLUE" },
                    { name: "WHITE", code: "WHITE" },
                    { name: "PEARL", code: "PEARL" },
                    { name: "YELLOW", code: "YELLOW" },
                    { name: "ORANGE", code: "ORANGE" },
                    { name: "WINE", code: "WINE" },
                    { name: "PINK", code: "PINK" },
                    { name: "PURPLE", code: "PURPLE" },
                    { name: "BROWN", code: "BROWN" },
                    { name: "BAIGE", code: "BAIGE" },
                    { name: "GOLD", code: "GOLD" },
                    { name: "SILVER", code: "SILVER" },
                    { name: "GRAY", code: "GRAY" },
                    { name: "BLACK", code: "BLACK" },
                    { name: "OTHER", code: "OTHER" },
                  ]}
                  optionLabel="name"
                  placeholder="Color"
                  className="w-full md:w-14rem"
                />
              </div>
              <div className="col-6 col-md-3 col-lg-3 margin-bottom-5">
                <Dropdown
                  value={searchObj.condition}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      condition: e.target.value,
                    })
                  }
                  options={[
                    { name: "DAMAGE", code: "DAMAGE" },
                    { name: "USED", code: "USED" },
                  ]}
                  optionLabel="name"
                  placeholder="Condition"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="row text-center">
              <div
                className="col-12 col-md-6 col-lg-6"
                style={{ marginTop: 25 }}
              >
                <div className="slider-text-inline">
                  <span className="slider-left-text">Mileage</span>
                  <p className="range-text">
                    {searchObj.mileageStart +
                      "km to " +
                      searchObj.mileageEnd +
                      "km"}
                  </p>
                </div>
                <Slider
                  value={[searchObj.mileageStart, searchObj.mileageEnd]}
                  min={0}
                  max={100000}
                  step={1}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      mileageStart: e.value[0],
                      mileageEnd: e.value[1],
                    })
                  }
                  range
                />
              </div>
              <div className="col-6 col-md-3 col-lg-3 margin-bottom-5">
                <Dropdown
                  value={searchObj.fuelType}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      fuelType: e.value,
                    })
                  }
                  options={[
                    { name: "GASOLINE", code: "GASOLINE" },
                    { name: "DIESEL", code: "DIESEL" },
                    { name: "HYBRID", code: "HYBRID" },
                    { name: "ELECTRIC", code: "ELECTRIC" },
                  ]}
                  optionLabel="name"
                  placeholder="Fuel Type"
                  className="w-full md:w-14rem"
                />
              </div>
              <div className="col-6 col-md-3 col-lg-3 margin-bottom-5">
                <Dropdown
                  value={searchObj.bodyType}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      bodyType: e.value,
                    })
                  }
                  options={[
                    { name: "SEDAN", code: "SEDAN" },
                    { name: "COUPE", code: "COUPE" },
                    { name: "HATCHBACK", code: "HATCHBACK" },
                    { name: "STATION WAGON", code: "STATION WAGON" },
                    { name: "SUV", code: "SUV" },
                    { name: "PICK UP", code: "PICK UP" },
                    { name: "VAN", code: "VAN" },
                    { name: "MINI VAN", code: "MINI VAN" },
                    { name: "WAGON", code: "WAGON" },
                    { name: "CONVERTIBLE", code: "CONVERTIBLE" },
                    { name: "BUS", code: "BUS" },
                    { name: "TRUCK", code: "TRUCK" },
                    { name: "HEAVY EQUIP", code: "HEAVY EQUIP" },
                    { name: "FORKLIFT", code: "FORKLIFT" },
                    { name: "BIKE", code: "BIKE" },
                    { name: "KEI CAR", code: "KEI CAR" },
                  ]}
                  optionLabel="name"
                  placeholder="Body Type"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="row text-center">
              <div className="col-12 col-md-6 col-lg-6 margin-bottom-5 last-slider">
                <div className="slider-text-inline">
                  <span className="slider-left-text">Price</span>
                  <p className="range-text">
                    {searchObj.priceStart +
                      "yen to " +
                      searchObj.priceEnd +
                      "yen"}
                  </p>
                </div>
                <Slider
                  value={[searchObj.priceStart, searchObj.priceEnd]}
                  min={0}
                  max={10000000}
                  step={1}
                  onChange={(e) =>
                    setSearchObj({
                      ...searchObj,
                      priceStart: e.value[0],
                      priceEnd: e.value[1],
                    })
                  }
                  range
                />
              </div>

              <div className="col-12 col-md-6 col-lg-6 margin-bottom-5 display-flex-radios">
                <div className="col-4 col-md-2 col-lg-2 radios-border">
                  <div className="radios-heading">Steering Wheel</div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="Unspecified"
                        name="Unspecified"
                        value="Unspecified"
                        onChange={() => handleCheckboxChange('steeringWheel', 'Unspecified')}
                        checked={formData.steeringWheel.includes('Unspecified')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        Unspecified
                      </label>
                    </div>
                  </div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <div className="inner-radios">
                        <RadioButton
                          inputId="Unspecified"
                          name="Unspecified"
                          value="RHD"
                          onChange={() => handleCheckboxChange('steeringWheel', 'RHD')}
                          checked={formData.steeringWheel.includes('RHD')}
                        />
                        <label htmlFor="Unspecified" className="radios-label">
                          RHD
                        </label>
                      </div>
                    </div>
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="Unspecified"
                        name="Unspecified"
                        value="LHD"
                        onChange={() => handleCheckboxChange('steeringWheel', 'LHD')}
                        checked={formData.steeringWheel.includes('LHD')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        LHD
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-4 col-md-2 col-lg-2 radios-border">
                  <div className="radios-heading">Driving System</div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="Unspecified"
                        name="Unspecified"
                        value="Unspecified"
                        onChange={() => handleCheckboxChange('drivingSystem', 'Unspecified')}
                        checked={formData.drivingSystem.includes('Unspecified')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        Unspecified
                      </label>
                    </div>
                  </div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <div className="inner-radios">
                        <RadioButton
                          inputId="Unspecified"
                          name="Unspecified"
                          value="2WD"
                          onChange={() => handleCheckboxChange('drivingSystem', '2WD')}
                          checked={formData.drivingSystem.includes('2WD')}
                        />
                        <label htmlFor="Unspecified" className="radios-label">
                          2WD
                        </label>
                      </div>
                    </div>
                    <div className="radio-outer-content">
                      <RadioButton
                        inputId="Unspecified"
                        name="Unspecified"
                        value="4WD"
                        onChange={() => handleCheckboxChange('drivingSystem', '4WD')}
                        checked={formData.drivingSystem.includes('4WD')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        4WD
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-4 col-md-2 col-lg-2 radios-border">
                  <div className="radios-heading">Transmission</div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <RadioButton
                        name="Unspecified"
                        value="Unspecified"
                        onChange={() => handleCheckboxChange('transmission', 'Unspecified')}
                        checked={formData.transmission.includes('Unspecified')}
                      />
                      <label htmlFor="Unspecified" className="radios-label">
                        Unspecified
                      </label>
                    </div>
                  </div>
                  <div className="inner-radios">
                    <div className="radio-outer-content">
                      <div className="inner-radios">
                        <RadioButton
                          name="Unspecified"
                          value="AUTO"
                          onChange={() => handleCheckboxChange('transmission', 'AUTO')}
                          checked={formData.transmission.includes('AUTO')}
                        />
                        <label htmlFor="Unspecified" className="radios-label">
                          AT
                        </label>
                      </div>
                    </div>
                    <div
                      className="radio-outer-content"
                      style={{ marginLeft: 15 }}
                    >
                      <RadioButton
                        name="Unspecified"
                        value="MANUAL"
                        onChange={() => handleCheckboxChange('transmission', 'MANUAL')}
                        checked={formData.transmission.includes('MANUAL')}
                      />
                      <label
                        htmlFor="Unspecified"
                        className="radios-label"
                        style={{ marginLeft: 3 }}
                      >
                        MT
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="btn-wrapper-search">
              <button
                className="search-btn-1"
                onClick={() => {
                  onSearch(searchObj, collapse);
                }}
              >
                <i
                  style={{ marginRight: 10 }}
                  className="fa fa-search"
                  aria-hidden="true"
                ></i>
                Search
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default CustomSearch;
